import { useModal, useModalExtra } from '../Modal'

/**
 * @function useConfirmationModal 汎用的な確認モーダルを開くフック
 * @returns {function(object): Promise<void>}
 */
export const useConfirmationModal = () => {
  const showModal = useModal()
  const { _closeUpModal } = useModalExtra()

  /**
   * @param {object} props
   * @param {string} props.title - タイトル
   * @param {React.ReactNode} props.description - 説明
   * @param {string} [props.confirmName='実行'] - 確認ボタン名. Default is `'実行'`
   * @param {string} [props.cancelName='キャンセル'] - キャンセルボタン名. Default is `'キャンセル'`
   * @param {function(): Promise<void> | void} props.onClick - 実行時の処理
   * @param {boolean} [props.isCancel=true] - キャンセルボタンを表示するか. Default is `true`
   * @param {boolean} [props.isSpinnerDisabled=true] - スピナーを無効にするか. Default is `true`
   * @param {import('react').CSSProperties} [props.modalStyle] - モーダル幅等. Default is `{ width: '600px' }`
   */
  const openConfirmationModal = ({
    title,
    description,
    confirmName = '実行',
    cancelName = 'キャンセル',
    onClick,
    isCancel = true,
    isSpinnerDisabled = true,
    modalStyle = { width: '600px' }
  }) => {
    // 幅は modalStyle（React state 経由）で宣言的に適用する。
    // useModifyClassList による querySelector + classList.add / setTimeout 除去は
    // 画面遷移直後にメインスレッドが混雑するとレースで幅が当たらないため使用しない。
    return new Promise((res) => {
      showModal({
        title,
        description,
        isCancel,
        cancelName,
        isWide: false,
        isSpinnerDisabled,
        modalStyle,
        onClose: res,
        button: [
          {
            name: confirmName,
            className: 'footer-btn button_base',
            click: async () => {
              try {
                await onClick?.()
                _closeUpModal()
                res()
              } catch (error) {
                console.error(error)
              }
            },
            close: false
          }
        ]
      })
    })
  }

  return openConfirmationModal
}

/**
 * @function openMasterConfirmUpdateModal データ更新モダルを表示
 * @param {object} arg_0
 * @param {string} arg_0.title
 * @param {function():void} arg_0.onClick
 * @param {function():void} arg_0.onClose
 * @param {function( any ):void} arg_0.onError
 * @param {function( any ):void} arg_0.showModal
 */
export async function openMasterConfirmUpdateModal({ title, onClick, onError, showModal, onClose }) {
  try {
    // 幅は modalStyle（React state 経由）で宣言的に適用する（レース回避のため classList 操作は使わない）。
    await new Promise((res) => {
      showModal({
        title: title ?? 'マスター設定登録の確認',
        onClose: res,
        isWide: false,
        modalStyle: { width: '900px' },
        description: (
          <>
            <p>
              設定値を登録してダッシュボードに反映します。<span className="whitespace-nowrap">よろしいですか</span>
            </p>
            <p>※ダッシュボードへの反映には5分～10分程度かかります</p>
            <p>マスター管理画面のステータスから反映状況を確認してください</p>
          </>
        ),
        button: [
          {
            name: '実行',
            className: 'footer-btn button_base',
            click: onClick
          }
        ]
      })
    }).finally(() => {
      // onCloseが存在する場合のみ呼び出す
      if (onClose && typeof onClose === 'function') {
        onClose()
      }
    })
  } catch (error) {
    onError(error)
  }
}
